export const API_ASSET_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/+$/, '');

// Registry: Original-Pfad → Object-URL (blob:) eines vorab geladenen Assets.
// Wird vom Sync-Layer befuellt (AssetCache). Damit liefert assetUrl() offline
// die lokale Kopie, ohne dass die <img>-Aufrufstellen geaendert werden muessen.
const cachedObjectUrls = new Map<string, string>();

function normalizePath(value: string): string {
  return value.startsWith('/') ? value : `/${value}`;
}

// Roh-URL gegen den Server (fruehere assetUrl-Logik) — der Asset-Prefetcher
// laedt hierueber, damit er NICHT versehentlich die eigene blob:-Cache-URL holt.
export function networkAssetUrl(path: string | null | undefined): string {
  const value = path?.trim() ?? '';
  if (!value) return '';
  if (/^(https?:\/\/|data:|blob:)/i.test(value)) return value;
  return `${API_ASSET_BASE}${normalizePath(value)}`;
}

// Registriert/entfernt eine Offline-Kopie. registerCachedAsset wird beim
// App-Start (Rehydrate) und direkt nach jedem Asset-Download aufgerufen.
export function registerCachedAsset(path: string, objectUrl: string): void {
  const value = path?.trim();
  if (!value) return;
  const key = normalizePath(value);
  // Warum: falls derselbe Pfad doppelt registriert wird (Race rehydrate ↔
  // prefetch), die ALTE Object-URL freigeben — sonst leakt sie.
  const previous = cachedObjectUrls.get(key);
  if (previous && previous !== objectUrl) {
    try {
      URL.revokeObjectURL(previous);
    } catch {
      /* ignore */
    }
  }
  cachedObjectUrls.set(key, objectUrl);
}

export function clearCachedAssets(): void {
  for (const url of cachedObjectUrls.values()) {
    try {
      URL.revokeObjectURL(url);
    } catch {
      /* ignore */
    }
  }
  cachedObjectUrls.clear();
}

export function hasCachedAsset(path: string | null | undefined): boolean {
  const value = path?.trim() ?? '';
  if (!value) return false;
  return cachedObjectUrls.has(normalizePath(value));
}

export function assetUrl(path: string | null | undefined): string {
  const value = path?.trim() ?? '';
  if (!value) return '';
  if (/^(https?:\/\/|data:|blob:)/i.test(value)) return value;
  const cached = cachedObjectUrls.get(normalizePath(value));
  if (cached) return cached;
  return `${API_ASSET_BASE}${normalizePath(value)}`;
}